/**
 * Inventory list view mode: flat single-row vs grouped expandable rows.
 * Enable tabs here when backend grouped + single_row endpoints are ready.
 */

export const GROUPED_ROW_VIEW_SWITCH_LABEL = "Grouped Row View";

/** Tab index matches `tabsData` order in inventories module */
export const INVENTORY_VIEW_MODE_BY_TAB = {
  0: { enabled: false, route: "demand-forecast" },
  1: {
    enabled: true,
    route: "inventories",
    exportGrouped: "inventory_xlsx",
    exportSingleRow: "inventory_single_row_inventory_xlxs",
    subtableSpan: 12,
  },
  2: {
    enabled: false,
    route: "pipeline-teardown",
    // exportGrouped: "teardown_inventory_xlxs",
    // exportSingleRow: "teardown_inventory_single_row_xlxs",
     subtableSpan: 5,
  },
  3: {
    enabled: true,
    route: "under-stock",
    exportGrouped: "under_stock_inventory_xlxs",
    exportSingleRow: "under_stock_single_row_inventory_xlxs",
    subtableSpan: 12,
  },
  4: {
    enabled: true,
    route: "repair-orders",
    exportGrouped: "repair_orders_inventory_xlxs",
    exportSingleRow: "repair_orders_single_row_inventory_xlxs",
    subtableSpan: 12,
  },
  5: {
    enabled: false,
    route: "recommended-for-repairs",
    // exportGrouped: "repair_recommand_inventory_xlxs",
    // exportSingleRow: "repair_recommand_inventory_single_row_xlxs",
     subtableSpan: 8,
  },
  6: {
    enabled: true,
    route: "slow-moving",
    exportGrouped: "slowdown_inventory_xlxs",
    exportSingleRow: "slowdown_single_row_inventory_xlxs",
    subtableSpan: 8,
  },
};


export const getInventoryViewModeConfig = (tabIndex) =>
  INVENTORY_VIEW_MODE_BY_TAB[tabIndex];

export const showGroupedViewSwitch = (tabIndex) =>
  Boolean(getInventoryViewModeConfig(tabIndex)?.enabled);

export const getGroupedRowExportType = (tabIndex, isGroupedView) => {
  const config = getInventoryViewModeConfig(tabIndex);
  if (!config?.enabled) return null;
  return isGroupedView ? config.exportGrouped : config.exportSingleRow;
};
